/*
 * THESE MATERIALS CONTAIN CONFIDENTIAL INFORMATION AND TRADE SECRETS 
 * OF BMC SOFTWARE, INC. YOU SHALL MAINTAIN THE MATERIALS AS
 * CONFIDENTIAL AND SHALL NOT DISCLOSE ITS CONTENTS TO ANY THIRD
 * PARTY EXCEPT AS MAY BE REQUIRED BY LAW OR REGULATION. USE, 
 * DISCLOSURE, OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR 
 * EXPRESS WRITTEN PERMISSION OF BMC SOFTWARE, INC. 
 *
 * ALL BMC SOFTWARE PRODUCTS LISTED WITHIN THE MATERIALS ARE TRADEMARKS
 * OF BMC SOFTWARE, INC. ALL OTHER COMPANY PRODUCT NAMES ARE
 * TRADEMARKS OF THEIR RESPECTIVE OWNERS. 
 * 
 * © Copyright 2020 BMC Software, Inc. 
 * 
 */
(function($) {
    var $this = null;
    var userName = null;
    var CONNECT_STORAGE_NAME = 'hostConnectionLogon';
    var LAST_CONNECTION_NAME = 'lastHostConnection';
    var userIsLoggedOn = false;
    var busyText = logonBusyText;
    var initialText = null;
    var hciContext = '';
    var queryString = '';
    var caller = null;
    var reconnect = false;
    var hostConnectionLogonDialogID = '#hostConnectionLogonDialog';
    var hostConnectionLogon = JSON.parse(sessionStorage.getItem(CONNECT_STORAGE_NAME));
    var savedData = null;
    var changingPassword = false;
    var includeRuntimeConfiguration = false;
    var webServicePath = null;
    let allowChangePassword = true;
    const nullString = 'null';
 
    const nullToEmpty = function(input) {
        if (input) {
            if (input.toLowerCase() === nullString) {
                return '';
            }
            return input;
        }
        return '';
    }
    
    var enableButtons = function() {
        var inSession = true;
        var hostConnectionLogonString = sessionStorage.getItem(CONNECT_STORAGE_NAME);
        
        if (!hostConnectionLogonString) {
            // the user isn't currently logged in so see if their last connection is stored.
            inSession = false;
            hostConnectionLogonString = localStorage.getItem(LAST_CONNECTION_NAME + '_' + CONNECT_STORAGE_NAME);
        }
        
        if (!!hostConnectionLogonString) {
            hostConnectionLogon = JSON.parse(hostConnectionLogonString);
            
            if (hostConnectionLogon) {
                var connectionNames = $('#hostConnections > option');
                
                for (var index = 0; index < connectionNames.length; index++) {
                    if ($(connectionNames[index]).val() === String(hostConnectionLogon.connectionName)) {
                        $('#hostConnections').val(hostConnectionLogon.connectionName);
                        $('#hostUsername').val(nullToEmpty(hostConnectionLogon.userID));
                        $('#hostPassword').val('');
                        break;
                    }
                }
                
                if (inSession) {
                    userIsLoggedOn = true;
                }
            }
        }
        
        if (userIsLoggedOn) {
            if (reconnect) {
                $('.logon-button span').text(reconnectButtonText);
                $this.parent().find('div.ui-dialog-titlebar .ui-dialog-title').text(reconnectDialogTitle);
                $('#hostPassword').val('');
                busyText = logonBusyText;
                setAuthentication();
            }
        } else {
            $('.logoff-button').attr('disabled', 'disabled');
            $this.parent().find('div.ui-dialog-titlebar .ui-dialog-title').text(logonDialogTitle);
            setAuthentication();
            
            busyText = logonBusyText;
        }
    };
    
    var enableChangePasswordFields = function() {
        collapseChangePassword($('#changePasswordFields').hasClass("shown"));
    };
    
    const collapseChangePassword = function(collapse) {
        changingPassword = !collapse;
        $('#changePassword i')[changingPassword ? 'addClass' : 'removeClass']('fa-rotate-90');
        $('#changePasswordFields')[changingPassword ? 'addClass' : 'removeClass']('shown');
        if (!changingPassword) {
            $('#changePasswordFields input').val('');
        }
    }
    
    var setAuthentication = function() {
        // If only 1 authentication mode, disable the select
        if ($('#authentication option').length === 1) {
            $('#authentication').attr('disabled', 'disabled');
            enableLogonButton();
        } else {
            $('#authentication').removeAttr('disabled');
            
            if (x509mode) {
                // Make Smartcard the default
                $('#authentication').val(x509value);
                $('#hostUsername').attr('disabled', 'disabled');
                $('#hostPassword').attr('disabled', 'disabled');
                $('.logon-button').removeAttr('disabled');
            } else {
                enableLogonButton();
            }
        }
    };

    var enableLogonButton = function() {
        var mode = $('#authentication').val();
        var enable = false;
        
        var username = $('#hostUsername').val().trim();

        if (mode === x509value) {
            enable = true;
        } else if (mode === passTicketValue) {
            if (username.length > 0) {
                enable = true;
            }
        } else if (username.length > 0 && $('#hostPassword').val().trim().length > 0) {
            enable = true;
        }
        
        if($('#newPassword').val().trim().length !== $('#confirmPassword').val().trim().length ) {
            enable = false;
        }
            
        if (enable || userIsLoggedOn) {
            logonEnabled = true;
            $('.logon-button').removeAttr('disabled');
        } else {
            $('.logon-button').attr('disabled', 'disabled');
            
        }
    };
    
    var textFieldKeypressHandler = function(event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            var logonButton = $('.logon-button');

            if (logonButton.attr('disabled') !== 'disabled') {
                logonButton.click();
            }
        }
    };
    
    var addBusyOverlay = function() {
        if (typeof $.displayLoadingIndicator === 'function') {
            $.displayLoadingIndicator(busyText);
        } else {
            var busyOverlay = $('.busy-overlay')[0];
            
            if (!busyOverlay) {
                busyOverlay = $('.ui-widget-overlay').clone();
                busyOverlay.addClass('busy-overlay');
                busyOverlay.css('opacity', '0.0');
                busyOverlay.css('z-index', '1555');
                busyOverlay.css('cursor', 'wait');
                busyOverlay.appendTo('body');
            }
        }
    };
    
    var removeBusyOverlay = function() {
        if (typeof $.removeLoadingIndicator === 'function') {
            $.removeLoadingIndicator();
        } else {
            $('.busy-overlay').remove();
        }
    };
    
    var switchAuthentication = function() {
        var mode = $('#authentication').val();
        evalChangePassword();
        if (mode === x509value) {
            $('#hostUsername').attr('disabled', 'disabled');
            $('#hostPassword').attr('disabled', 'disabled');
            $('.logon-button').removeAttr('disabled');
        } else if (mode === passTicketValue) {
            $('#hostUsername').removeAttr('disabled');
            $('#hostPassword').attr('disabled', 'disabled');
            enableLogonButton();
        } else {
            $('#hostUsername').removeAttr('disabled');
            $('#hostPassword').removeAttr('disabled');
            enableLogonButton();
        }        
    };
    
    const evalChangePassword = function() {
        allowChangePassword = authenticationChangePasswordEnabled === $('#authentication').val();
        if (!allowChangePassword) {
            $('#newPassword').val('');
            $('#confirmPassword').val('');
            collapseChangePassword(true);
        }
        $('#changePasswordContainer')[allowChangePassword ? 'removeClass' : 'addClass']('hide');
    }
    
    var validateChangePasswordFields = function() {
        if ($('#newPassword').val() === $('#confirmPassword').val()) {
            return true;
        } else {
            $('.dialog-message').html(mismatchedNewPasswordsError);
            return false;
        }
    }
    
    var logIn = function(hostConnections) {
        var defer = $.Deferred();
        var hostName = null;
        var port = null;
        var sslConnection = null;
        var a = null;
        var b = null;
        var c = null;
        var d = null;
        var mode = $('#authentication').val();
        var connectionName = $('#hostConnections').val();
        var runtimeConfiguration = $('#runtimeConfiguration').val();
        
        if (!mode) {
            mode = uidvalue;
        }
        
        if (mode === uidvalue) {
            userName = $('#hostUsername').val();
            var encryptedPwd = Crypto.encrypt($('#hostPassword').val());
            
            if(!!encryptedPwd) {                                            
                a = encryptedPwd.iv;
                b = encryptedPwd.encrypted;                                         
            }
            
            if (changingPassword) {
                var encryptedNewPwd = Crypto.encrypt($('#newPassword').val());
                c = encryptedNewPwd.iv;
                d = encryptedNewPwd.encrypted;
            }
        }
        
        for (var index = 0; index < hostConnections.length; index++) {
            if (connectionName === String(hostConnections[index].hostConnectionName)) {
                hostName = hostConnections[index].connectionHost;
                port = hostConnections[index].connectionPort;
                sslConnection = hostConnections[index].sslConnection;
                break;
            }
        }

        var data = {
            authMode: mode,
            host : hostName,
            port : port,
            secureConnectionType : sslConnection,
            sysName : connectionName,
            nocache : new Date().getTime()
        }
        
        if (mode === passTicketValue) {
            userName = $('#hostUsername').val();
            data.lgid = userName;
        }

        if (mode === uidvalue) {
            data.lgid = userName;
            data.lgpw = encryptedPwd;
            data.parama = a;
            data.paramb = b;
            data.paramc = c;
            data.paramd = d;
        }
        
        if (includeRuntimeConfiguration) {
            data.rtConfig = runtimeConfiguration;
        }
        
        var loginPath;
        var wsType;
        
        if (webServicePath === 'iBrowser') {
            loginPath = 'ws/sessions';
            wsType = "POST";
            data = JSON.stringify(data);
        } else if (webServicePath != null) {
            loginPath = webServicePath + '/sessions';
            wsType = "POST";
            data = JSON.stringify(data);
        }
        else {
            loginPath = 'hci/logon';
            wsType = "GET";
        }
        
        $.when(
            $.ajax({
                type: wsType,
                url: hciContext + loginPath + queryString,
                data: data,
                dataType: "json",
                contentType : "json"
            })
        ).done(function(response) {
            hostConnectionLogon = response.hostConnectionLogon;
            
            if (hostConnectionLogon) {
                var logonToken = hostConnectionLogon.logonToken;
                var hostName = hostConnectionLogon.hostName;
                
                if (logonToken && hostName) {
                    hostConnectionLogon.connectionName = connectionName;
                    sessionStorage.setItem(CONNECT_STORAGE_NAME, JSON.stringify(hostConnectionLogon));
                    localStorage.setItem(LAST_CONNECTION_NAME + '_' + CONNECT_STORAGE_NAME, JSON.stringify(hostConnectionLogon));
                }
                
                savedData = data;
                defer.resolve();
            } else {
                $('.dialog-message').html(response.errorMessage);
                defer.reject(response);
            }
        }).fail(function(response) {
            if (!!response && !!response.responseJSON && !!response.responseJSON.message && !response.errorMessage) {
                response.errorMessage = response.responseJSON.message;
            }
            
            defer.reject(response);
        });
        
        return defer.promise();
    };
    
    //compare function before sorting an array of objects by a specific array property to get sort order
    var compareByHostProperty = function compareByHostProperty(prop) { 
    	
        return function(a, b) {  
        	
	        	 let elementA = a[prop].toLowerCase();
	          	 let elementB = b[prop].toLowerCase();
		         
	          	 if (elementA > elementB) {    
		                return 1; 
	          	 } else if (elementA < elementB) {    
		                return -1;    
		         }    
		         return 0;    
         }    
    };

    var logoff = function(hostConnections) {
        var hostConnectionLogon = JSON.parse(sessionStorage.getItem(CONNECT_STORAGE_NAME));
        
        var logoutPath;
        var wsType;
        
        if (webServicePath === 'iBrowser') {
            logoutPath = 'ws/sessions';
            wsType = 'DELETE';
        } else if (webServicePath != null) {
            logoutPath = webServicePath + '/session/logout';
            wsType = 'DELETE';
        } else {
            logoutPath = 'hci/logoff';
            wsType = 'GET';
        }
        
        var data = {
            sysName : hostConnectionLogon.connectionName,
            lgid : hostConnectionLogon.userID,
            logonToken : hostConnectionLogon.logonToken,
            nocache : new Date().getTime()
        } 
        
        $.when(
            $.ajax({
                type: wsType,
                url: hciContext + logoutPath + queryString,
                data: data,
                dataType: "json",
                contentType : 'json'
            })
        ).done(function(response) {
            var hostConnectionLogoff = response.hostConnectionLogoff;
            
            if (hostConnectionLogoff) {
                sessionStorage.removeItem(CONNECT_STORAGE_NAME);
                
                if(!!hostConnections && reconnect) {
                    $.when(
                        logIn(hostConnections)
                    ).done(function() {
                        if (!!caller && caller.hasClass('login-wrapper')) {
                            $.animateCloseDialog(hostConnectionLogonDialogID, '.login-wrapper');
                        } else {
                            $(hostConnectionLogonDialogID).dialog('close');
                        }
                        
                        removeBusyOverlay();
                        $(window).trigger('hostConnectionLogon', [hostConnectionLogon]);
                    }).fail(function() {
                        userIsLoggedOn = false;
                        $('.dialog-message').html(unableToConnectError);
                        removeBusyOverlay();
                    }).always(function() {
                        localStorage.setItem('hostConnectionUser', userName);
                        localStorage.setItem('hostConnectionRuntimeConfiguration', $('#runtimeConfiguration').val());
                    });
                } else {
                    if (!!caller && caller.hasClass('login-wrapper')) {
                        $.animateCloseDialog(hostConnectionLogonDialogID, '.login-wrapper');
                    } else {
                        $(hostConnectionLogonDialogID).dialog('close');
                    }
                    
                    $(window).trigger('hostConnectionLogoff');
                }
            } else if (response.errorMessage) {
                $('.dialog-message').html(response.errorMessage);
            }
        }).always(function() {
            removeBusyOverlay();
        });
    };
    
    this.addBusyOverlay = addBusyOverlay;
    this.removeBusyOverlay = removeBusyOverlay;
    $.extend({
        showHostConnectionLogonDialog : function(options) {
            savedData = null;
            
            if (typeof this !== 'function') {
                caller = $(this);
            }
            
            if (options) {
                if (options.dialogID) {
                    hostConnectionLogonDialogID = options.dialogID;
                }
                
                if (options.reconnect) {
                    reconnect = options.reconnect;
                } 
                
                initialText = '';
                
                if (options.message) {
                    initialText = options.message;
                }
                
                hciContext = '';
                
                if (options.hciContext) {
                    hciContext = options.hciContext;
                }
                
                queryString = '';
                
                if (options.queryString) {
                    queryString = options.queryString;
                }
                
                if (options.includeRuntimeConfiguration) {
                    includeRuntimeConfiguration = options.includeRuntimeConfiguration;
                }
                
                if (options.webServicePath) {
                    webServicePath = options.webServicePath;
                }
                
                CONNECT_STORAGE_NAME = (!!options.storageName)? options.storageName : CONNECT_STORAGE_NAME; //Set the storage name - for SQLAF
            }
            
            $.when(
                $.getJSON('../compuware/ws/Config/hostConnections', {
                    nocache : new Date().getTime()
                })
            ).always(function(response) {
                var hostConnections = [];
                var hostConnectionsResponse = response.HostConnectionInfoResponse;
                
                if (hostConnectionsResponse) {
                    var hostConnectionInfoList = hostConnectionsResponse.hostConnectionInfoList;
                    
                    if (hostConnectionInfoList && hostConnectionInfoList !== '') {
                        var hostConnectionInfo = hostConnectionInfoList.hostConnectionInfo;
                        
                        if (hostConnectionInfo && $.isArray(hostConnectionInfo)) {
                            hostConnections = hostConnectionInfo;
                        } else {
                            hostConnections.push(hostConnectionInfo);
                        }
                    }
                }
                
                if (hostConnections.length > 0) {
                	hostConnections = hostConnections.sort(compareByHostProperty('hostConnectionName'));//Sorting hostConnections array by a hostConnectionName 
                    for (var index = 0; index < hostConnections.length; index++) {
                        var connection = hostConnections[index].hostConnectionName;
                        $('#hostConnections').append('<option value="' + connection + '">' + connection + '</option>');
                    }
                    
                    var buttons = {
                        Logon : {
                            text : logonButtonText,
                            'class': 'logon-button',
                            click: function() {
                                $('.dialog-message').html('');
                                
                                if(changingPassword && !validateChangePasswordFields()) {
                                    return;
                                }

                                addBusyOverlay();
                                
                                if (!userIsLoggedOn) {
                                    $.when(
                                        logIn(hostConnections)
                                    ).done(function() {                                           
                                        if (!!caller && caller.hasClass('login-wrapper')) {
                                            $.animateCloseDialog(hostConnectionLogonDialogID, '.login-wrapper');
                                        } else {
                                            $(hostConnectionLogonDialogID).dialog('close');
                                        }
                                        
                                        removeBusyOverlay();
                                        $(window).trigger('hostConnectionLogon', [hostConnectionLogon, savedData]);
                                    }).fail(function(response) {
                                        removeBusyOverlay();
                                        var errorMessage = unableToConnectError;
                                        
                                        if (!!response && !!response.errorMessage) {
                                            errorMessage = response.errorMessage;                                            
                                        }
                                        
                                        $('.dialog-message').html(errorMessage);
                                    }).always(function() {
                                        localStorage.setItem('hostConnectionUser', userName);
                                        localStorage.setItem('hostConnectionRuntimeConfiguration', $('#runtimeConfiguration').val());
                                    });
                                } else {
                                    logoff(hostConnections);
                                }
                            }
                        },
                        Cancel : {
                            text : cancelButtonText,
                            click : function() {
                                if (!!caller && caller.hasClass('login-wrapper')) {
                                    $.animateCloseDialog(hostConnectionLogonDialogID, '.login-wrapper');
                                } else if (!!caller && caller.hasClass('table-delete-button')) {
                                    $.animateCloseDialog(hostConnectionLogonDialogID, '.table-delete-button');
                                } else {
                                    $(hostConnectionLogonDialogID).dialog('close');
                                }
                                
                                if (!userIsLoggedOn) {
                                    $(window).trigger('hostConnectionCancelled');
                                }
                            }                                                    
                        }
                    };
                    
                    $(hostConnectionLogonDialogID).dialog({
                        width: 400,
                        modal: true,
                        draggable : false,
                        resizable : false,
                        title : titleText,
                        classes: {'ui-dialog': 'cpwr-ui-dialog hostConnectionLogonDialog'},
                        buttons : buttons,
                        open: function() {
                            if (!!caller && caller.hasClass('login-wrapper')) {
                                $.animateOpenDialog(hostConnectionLogonDialogID, '.login-wrapper');
                            } else if (!!caller && caller.hasClass('table-delete-button')) {
                                $.animateOpenDialog(hostConnectionLogonDialogID, '.table-delete-button');
                            }
                            
                            $this = $(this);
                            userIsLoggedOn = false;
                            $(this).off('keypress', textFieldKeypressHandler);
                            $('.dialog-message').html(initialText);
                            $('#hostConnections').removeAttr('disabled');
                            
                            if (includeRuntimeConfiguration) {
                                $('#runtimeConfiguration').val(localStorage.getItem('hostConnectionRuntimeConfiguration'));
                                $('#runtimeConfigurationWrapper').show();
                            }
                            
                            $('#hostUsername').removeAttr('disabled');
                            $('#hostUsername').val(nullToEmpty(localStorage.getItem('hostConnectionUser')));
                            $('#hostPassword').removeAttr('disabled');
                            $('#hostPassword').val('');
                            enableButtons();
                            enableLogonButton();
                            
                            $(this).on('keypress', textFieldKeypressHandler);
                            $(window).trigger('hostConnectionOpen');
                            evalChangePassword();
                        },
                        close: function() {
                            $(window).trigger('hostConnectionClosed');
                            $('.dialog-message').html('');
                            $('#hostConnections').html('');
                            $('#runtimeConfigurationWrapper').hide();
                            $('#hostUsername').removeAttr('disabled');
                            $('#hostUsername').val('');
                            $('#hostPassword').removeAttr('disabled');
                            $('#hostPassword').val('');
                            $('.logon-button').removeAttr('disabled');
                        }
                    });
                } else {
                    // No connections defined - Does user want to know?
                    $(window).trigger('noHostConnections');
                }
            });
        }
    });
    
    $('#hostUsername').on('input', enableLogonButton);
    $('#hostPassword').on('input', enableLogonButton);
    $('#newPassword').on('input', enableLogonButton);
    $('#confirmPassword').on('input', enableLogonButton);
    $('#authentication').on('change', switchAuthentication);
    $('#changePassword').on('click', enableChangePasswordFields);
    window.hostLogonDialog = this;
})(jQuery);
